module.exports = __webpack_public_path__ + "static/media/Avisha Lad_ Resume.66216f34.pdf";